export default __webpack_public_path__ + "static/media/em-banner2-en.32eeb345.png";